import { useAppSelector } from '../../Reducers/store';
import { useEffect, useState } from 'react';
import { UserLevelNames } from '../../Models/UserLevel';
import { Button, Tooltip } from 'flowbite-react';
import { HiOutlinePlus } from 'react-icons/hi';
import SitePagesList from './SitePagesList';
import Loader from '../Common/Loader';
import { SitePage } from '../../Models/SitePage';
import EditSitePage from './EditSitePage';
import SitePageApi from '../../Api/SitePageApi';

export default function MemberSitePages() {
  const { userModel } = useAppSelector((state) => state.user);
  const [showAddEditSitePage, setShowAddEditSitePage] =
    useState<boolean>(false);
  const [selectedSitePage, setSelectedSitePage] = useState<number | null>(null);

  const [pagesData, setPagesData] = useState<SitePage[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    // getSitePages();
    // checkAccess();
  }, []);

  useEffect(() => {
    if (!showAddEditSitePage) getSitePages();
  }, [showAddEditSitePage]);

  const getSitePages = () => {
    try {
      setIsLoading(true);
      return SitePageApi.getSitePageList()
        .then((res) => {
          setPagesData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {});
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  function checkAccess() {
    if (
      userModel &&
      //   id &&
      //   ((userModel.memberId === Number(id) &&
      userModel.userLevelId === UserLevelNames.Admin
    ) {
      return true;
    } else {
      return false;
    }
  }

  const handleAddSitePageClick = () => {
    setSelectedSitePage(null);
    setShowAddEditSitePage(true);
  };

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Site Pages</div>
              </h1>
            </div>
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className=''>
            <SitePagesList
              data={pagesData}
              setSelectedSitePage={setSelectedSitePage}
              setShowSitePage={setShowAddEditSitePage}
              accessCheck={checkAccess()}
            />
          </div>
        </div>
        <EditSitePage
          selectedSitePage={selectedSitePage}
          show={showAddEditSitePage}
          setShow={setShowAddEditSitePage}
        />
        {/* add/edit sitepage */}
      </div>
    </>
  );
}
